// import React, { useEffect, useCallback, useMemo, useState } from "react";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-button.svg";
// import { Button } from "antd";
// import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filter-icon.svg";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
// import SupportFilter from "./SupportFilter/SupportFilter";
// import { useNavigate } from "react-router-dom";
// import { getApi } from "../../../../api/api_instance";
// import { API_URLS } from "../../../../api/apiUrls";
// import dayjs from "dayjs";
// import { THEME_COLORS } from "../../../../color";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// const Support = () => {
//   const [filterOpen, setFilterOpen] = useState(false);
//   const navigate = useNavigate();
//   const [status, setStatus] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [pageNo, setPageNo] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [tickets, setTickets] = useState([]);
//   const pageSize = 10;

//   const headers = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Ticket ID", key: "ticketId" },
//       { label: "Created On", key: "createdOn" },
//       { label: "Status", key: "status" },
//       { label: "Action", key: "action" },
//     ],
//     [],
//   );

//   const fetchTableData = useCallback(
//     async (page = 1, status) => {
//       try {
//         setLoading(true);
//         console.log("checkedItems", status);
//         const response = await getApi({
//           apiUrl: API_URLS.ALL_TICKETS(page, pageSize, status, searchTerm),
//         });

//         console.log("Fetched tickets:", response);
//         if (response.success) {
//           const pageData = response.data.tickets.map((item, index) => ({
//             key: item._id,
//             serial: index + 1,
//             ticketId: item._id,
//             status: item.status,
//             createdOn: dayjs(item.createdAt).format("DD/MM/YYYY"),
//             action: (
//               <EyeIcon
//                 style={{
//                   fontSize: "18px",
//                   cursor: "pointer",
//                   color: "#0087A3",
//                 }}
//                 onClick={() =>
//                   navigate(`/organization/support/chat/${item._id}`)
//                 }
//               />
//             ),
//           }));

//           setTickets(pageData);
//           setTotal(response.data.pagination?.totalDocs || 0);
//         } else {
//           setTickets([]);
//           setTotal(0);
//         }
//       } catch (error) {
//         console.error("Error fetching static pages:", error);
//         setTickets([]);
//         setTotal(0);
//       } finally {
//         setLoading(false);
//       }
//     },
//     [searchTerm, navigate],
//   );
//   useEffect(() => {
//     fetchTableData(pageNo, status);
//   }, [pageNo, status, searchTerm]);

//   const filteredData = useMemo(() => {
//     let data = [...tickets];

//     // if (sortBy && sortOrder) {
//     //   data = SortData({ data, key: sortBy, order: sortOrder });
//     // }

//     return data;
//   }, [tickets]);

//   return (
//    <div className="w-full max-w-full overflow-x-hidden">
//        <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2  ">
//           <p>Home</p>
//           <span>/</span>
//           <TextStyles style={{ color: "#06513D" }}>  Support</TextStyles>
//         </div>
//         <div className="flex items-center gap-2 sm:gap-3 mb-1 text-lg sm:text-xl font-bold flex-wrap">
//                 <IoArrowBackCircleOutline
//                   onClick={() => navigate(-1)}
//                   className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer flex-shrink-0"
//                 />
//                 <div className="text-[#06513D] font-[Calibri] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
//                  Support
//                 </div>
//               </div>
//       <div
//         style={{
//           border: "1px solid #3BA2B959",
//           borderRadius: "10px",
//           paddingTop: "20px",
//           boxShadow: "0px 0px 16px 0px #3BA2B91F",
//           backgroundColor:"#fff"
//         }}
//       >
//         <div className="flex justify-between mx-8">
//           <div className="  flex items-center gap-5 mb-4">
//             <div
//               style={{
//                 background: "#B6D4D933",
//                 height: "40px",
//               }}
//               className="px- border border-[#06513D] rounded-md text-[#06513D] text-base font-light"
//             >
//               <p
//                 style={{
//                   fontFamily: "Calibri",
//                   fontWeight: "300",
//                   fontSize: "16px",
//                   lineHeight: "24px",
//                   letterSpacing: "0%",
//                 }}
//                 className="pt-2 px-2"
//               >
//                 TOTAL TICKETS {total}
//               </p>
//             </div>
//             <SearchBar width="300px" onSearch={setSearchTerm} />
//           </div>
//           <div className="flex gap-5">
//             <Button
//               style={{ background: THEME_COLORS.green }}
//               className="text-[12px] font-light px-2 py-5 text-white"
//               onClick={() =>
//                 navigate("/organization/support/create-new-tickets")
//               }
//             >
//               + CREATE NEW TICKET
//             </Button>
//             <Button
//               style={{
//                 background: "#B6D4D9",
//                 border: "solid 1px #0087A3",
//                 color: THEME_COLORS.green,
//               }}
//               className="text-[12px]  font-light px-4 py-5"
//               onClick={() => setFilterOpen(true)}
//             >
//               <FilterIcon /> FILTER
//             </Button>
//           </div>
//         </div>
//         <Tables
//           headers={headers}
//           data={filteredData}
//           pageSize={pageSize}
//           current={pageNo}
//           total={total}
//           loading={loading}
//           onChange={(page) => setPageNo(page)}
//           // sortBy={sortBy}
//           // sortOrder={sortOrder}
//           // onSort={handleSort}
//         />
//       </div>
//       {filterOpen && (
//         <SupportFilter
//           onOpen={filterOpen}
//           onClose={() => setFilterOpen(false)}
//           setStatus={setStatus}
//         />
//       )}
//     </div>
//   );
// };

// export default Support;

import React, { useEffect, useCallback, useMemo, useState } from "react";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as BackIcon } from "../../../../assets/svgs/back-button.svg";
import { Button } from "antd";
import { ReactComponent as FilterIcon } from "../../../../assets/svgs/filter-icon.svg";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import { ReactComponent as EyeIcon } from "../../../../assets/svgs/eye-icon.svg";
import SupportFilter from "./SupportFilter/SupportFilter";
import { useNavigate, useLocation } from "react-router-dom";
import { getApi } from "../../../../api/api_instance";
import { API_URLS } from "../../../../api/apiUrls";
import dayjs from "dayjs";
import { THEME_COLORS } from "../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import PermissionForm from "../../../Auth/PermissionForm";
const Support = () => {
  const [filterOpen, setFilterOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [showPermission, setPermission] = useState(false);
  const [status, setStatus] = useState(state?.status || "");
  const [searchTerm, setSearchTerm] = useState(state?.searchTerm || "");
  const [pageNo, setPageNo] = useState(state?.pageNo || 1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [tickets, setTickets] = useState([]);
  const pageSize = 10;

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Ticket ID", key: "ticketId" },
      { label: "Created On", key: "createdOn" },
      { label: "Status", key: "status" },
      { label: "Action", key: "action" },
    ],
    [],
  );

  const fetchTableData = useCallback(
    async (page = 1, status) => {
      try {
        setLoading(true);
        console.log("checkedItems", status);
        const response = await getApi({
          apiUrl: API_URLS.ALL_TICKETS(page, pageSize, status, searchTerm),
        });

        console.log("Fetched tickets:", response);
        if (response.success) {
          const pageData = response.data.tickets.map((item, index) => ({
            key: item._id,
            serial: (
              <div className="text-center" title="">
                {index + 1}
              </div>
            ),
            ticketId: (
              <div className="text-center justify-center items-center" title="">
                {item._id}
              </div>
            ),
            status: (
              <div className="text-center" title="">
                {item.status}
              </div>
            ),
            createdOn: (
              <div className="text-center" title="">
                {dayjs(item.createdAt).format("DD/MM/YYYY")}
              </div>
            ),
            action: (
              <div className="flex justify-center items-center" title="">
                <EyeIcon
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#0087A3",
                  }}
                  className="w-4 h-4 sm:w-5 sm:h-5"
                  onClick={() =>
                    navigate(`/organization/support/chat/${item._id}`, {
                      state: { pageNo, searchTerm, status },
                    })
                  }
                />
              </div>
            ),
          }));

          setTickets(pageData);
          setTotal(response.data.pagination?.totalDocs || 0);
        } else {
          setTickets([]);
          setTotal(0);
        }
      } catch (error) {
        console.error("Error fetching static pages:", error);
        setTickets([]);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    },
    [searchTerm, navigate, pageNo, status],
  );

  useEffect(() => {
    fetchTableData(pageNo, status);
  }, [pageNo, status, searchTerm]);

  const filteredData = useMemo(() => {
    let data = [...tickets];
    return data;
  }, [tickets]);

  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;

  //console.log(isPermissionCompleted, "PermissionFormPermissionForm");

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  return (
    <div className="w-full max-w-full overflow-x-hidden">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm
          permissionConClose={() => setPermission(false)}
          //  permissionConClose={handlePermissionClose}
          // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
        />
      )}
      {/* Main Container */}
      <div className="px-3 sm:px-4 md:px-6 lg:px-0 mb-20 sm:mb-6 md:mb-6">
        {/* Breadcrumbs */}
        <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2 ">
          <p>Home</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>Support</TextStyles>
        </div>

        {/* Header Section */}
        <div className="flex items-center gap-2 sm:gap-3  text-lg sm:text-xl font-bold flex-wrap">
          {/* <IoArrowBackCircleOutline
            onClick={() => navigate(-1)}
            className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer flex-shrink-0"
          /> */}
          <div className="text-[#06513D] font-[Calibri] text-[16px] sm:text-[18px] md:text-[20px] font-bold">
            Support
          </div>
        </div>

        {/* Main Content Card */}
        <div
          className="w-full overflow-hidden"
          style={{
            border: "1px solid #3BA2B959",
            borderRadius: "10px",
            paddingTop: "15px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
            backgroundColor: "#fff",
          }}
        >
          {/* Controls Section */}
          <div className="px-3 sm:px-4 md:px-6 lg:px-8 mb-4">
            {/* Desktop Layout */}
            <div className="hidden lg:flex justify-between items-center">
              <div className="flex gap-5 items-center">
                {/* <div
                  style={{
                    background: "#B6D4D933",
                    height: "40px",
                  }}
                  className="px-4 border border-[#06513D] rounded-md text-[#06513D] text-base font-light flex items-center"
                >
                  <p
                    style={{
                      fontFamily: "Calibri",
                      fontWeight: "300",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0%",
                    }}
                  >
                    TOTAL TICKETS {total}
                  </p>
                </div> */}

                <div className="flex gap-4 items-center">
                  <div className=" px-2 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#B6D4D933] rounded-md text-[#06513D] text-sm xl:text-base font-light whitespace-nowrap">
                    TOTAL TICKETS {total}
                  </div>
                </div>

                {/* <SearchBar
                  width="300px"
                  height="40px"
                  onSearch={setSearchTerm}
                /> */}
              </div>
              <div className="flex gap-5">
                <Button
                  style={{ background: THEME_COLORS.green }}
                  className="text-[12px] font-light px-4 py-5 hover:!border-[#06513D] hover:!bg-[#387464] hover:!text-white text-white h-[40px] flex items-center"
                  onClick={() =>
                    navigate("/organization/support/create-new-tickets")
                  }
                >
                  + CREATE NEW TICKET
                </Button>
                <Button
                  style={{
                    background: "#B6D4D9",
                    border: "solid 1px #0087A3",
                  }}
                  className="text-[12px] font-light px-4 py-5 text:[#06513D] hover:!border-[#06513D] hover:!bg-[#F8F8F8] hover:!text-[#06513D] !border-[#06513D] h-[40px] flex items-center "
                  onClick={() => setFilterOpen(true)}
                >
                  <FilterIcon className="mr-2" />
                  FILTER
                </Button>
              </div>
            </div>

            {/* Tablet Layout */}
            <div className="hidden md:flex lg:hidden flex-col gap-3">
              <div className="flex justify-between items-center">
                <div
                  style={{
                    background: "#B6D4D933",
                    height: "36px",
                  }}
                  className="px-3 border border-[#06513D] rounded-md text-[#06513D] text-sm font-light flex items-center"
                >
                  <p
                    style={{
                      fontFamily: "Calibri",
                      fontWeight: "300",
                      fontSize: "14px",
                      lineHeight: "20px",
                      letterSpacing: "0%",
                    }}
                  >
                    TOTAL TICKETS {total}
                  </p>
                </div>
                <div className="flex gap-3">
                  <Button
                    style={{ background: THEME_COLORS.green }}
                    className="text-[11px] font-light px-3 text-white h-[36px] flex items-center"
                    onClick={() =>
                      navigate("/organization/support/create-new-tickets")
                    }
                  >
                    + CREATE TICKET
                  </Button>
                  <Button
                    style={{
                      background: "#B6D4D9",
                      border: "solid 1px #0087A3",
                      color: THEME_COLORS.green,
                    }}
                    className="text-[11px] font-light px-3 h-[36px] flex items-center"
                    onClick={() => setFilterOpen(true)}
                  >
                    <FilterIcon className="mr-1 w-3 h-3" />
                    FILTER
                  </Button>
                </div>
              </div>
              <div className="w-full">
                <SearchBar
                  width="100%"
                  height="36px"
                  onSearch={setSearchTerm}
                />
              </div>
            </div>

            {/* Mobile Layout */}
            <div className="flex md:hidden flex-col gap-3">
              <div className="flex justify-between items-center">
                <div
                  style={{
                    background: "#B6D4D933",
                    height: "32px",
                  }}
                  className="px-2 border border-[#06513D] rounded-md text-[#06513D] text-xs font-light flex items-center"
                >
                  <p
                    style={{
                      fontFamily: "Calibri",
                      fontWeight: "300",
                      fontSize: "12px",
                      lineHeight: "18px",
                      letterSpacing: "0%",
                    }}
                  >
                    TICKETS {total}
                  </p>
                </div>
                <Button
                  style={{
                    background: "#B6D4D9",
                    border: "solid 1px #0087A3",
                    color: THEME_COLORS.green,
                  }}
                  className="text-[10px] font-light px-2 h-[32px] flex items-center"
                  onClick={() => setFilterOpen(true)}
                >
                  <FilterIcon className="mr-1 w-3 h-3" />
                  FILTER
                </Button>
              </div>
              <div className="w-full">
                <SearchBar
                  width="100%"
                  height="32px"
                  onSearch={setSearchTerm}
                />
              </div>
              <div className="w-full">
                <Button
                  style={{ background: THEME_COLORS.green }}
                  className="text-[11px] font-light px-3 text-white h-[32px] flex items-center justify-center w-full"
                  onClick={() =>
                    navigate("/organization/support/create-new-tickets")
                  }
                >
                  + CREATE NEW TICKET
                </Button>
              </div>
            </div>
          </div>

          {/* Table Section */}
          <div className="w-full overflow-x-auto">
            <Tables
              headers={headers}
              data={filteredData}
              pageSize={pageSize}
              current={pageNo}
              total={total}
              loading={loading}
              onChange={(page) => setPageNo(page)}
            />
          </div>
        </div>

        {/* Filter Dialog */}
        {filterOpen && (
          <SupportFilter
            onOpen={filterOpen}
            onClose={() => setFilterOpen(false)}
            setStatus={setStatus}
            selectedStatus={status}
          />
        )}
      </div>
    </div>
  );
};

export default Support;
